// Use the live backend for appointments
const API_LINK = 'https://appointments.yjcandwellness.com/apii/';


export default API_LINK;
